const SmartLocksSectionStyles = {
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      padding: '100px 0', // Added consistent spacing above & below for smoother flow
    },
    leftSide: {
      backgroundColor: '#000',
      color: '#fff',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '80px 60px', // Increased padding for better spacing
      borderTopLeftRadius: '50px', // Adds smooth curve for better integration
      borderBottomLeftRadius: '50px',
    },
    textContainer: {
      textAlign: 'left',
      maxWidth: '500px',
    },
    boldText: {
      fontWeight: 'bold',
      fontSize: '1.6rem',
    },
    description: {
      fontSize: '1.1rem',
      marginTop: '15px',
      lineHeight: '1.7',
    },
    link: {
      color: '#81c241',
      textDecoration: 'underline',
      fontWeight: 'bold',
      '&:hover': {
        color: '#6aa832',
      },
    },
    note: {
      fontSize: '1.1rem',
      marginTop: '20px',
      fontStyle: 'italic',
    },
    arrow: {
      fontSize: '2rem',
      marginTop: '10px',
    },
    shopButton: {
      backgroundColor: '#81c241',
      color: '#fff',
      fontSize: '1.2rem',
      fontWeight: 'bold',
      padding: '14px 28px',
      borderRadius: '8px',
      marginTop: '15px',
      transition: 'all 0.3s ease-in-out',
      '&:hover': {
        backgroundColor: '#6aa832',
        transform: 'scale(1.05)',
      },
    },
    rightSide: {
      backgroundColor: '#fff',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '80px 60px',
      borderTopRightRadius: '50px', // Adds smooth curve
      borderBottomRightRadius: '50px',
      boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.1)', // Subtle shadow for smooth blending
    },
    imageContainer: {
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
    },
    image: {
      width: '100%',
      maxWidth: '500px',
    },
  };
  
  export default SmartLocksSectionStyles;
  